"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownList = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const react_router_dom_1 = require("react-router-dom");
class DropDownList extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            this.setState({
                dropdownOpen: !this.state.dropdownOpen
            });
        };
        this.state = {
            dropdownOpen: false
        };
    }
    render() {
        const { tagStore, type } = this.props;
        if (!tagStore) {
            return null;
        }
        let first = -1;
        return (React.createElement(reactstrap_1.Dropdown, { isOpen: this.state.dropdownOpen, toggle: this.toggle },
            React.createElement(reactstrap_1.DropdownToggle, { caret: true, size: "sm" },
                React.createElement(react_intl_1.FormattedMessage, { id: `tag.box.filter.${tagStore.nbSelected > 0 ? 'not_empty' : 'empty'}` })),
            React.createElement(reactstrap_1.DropdownMenu, { right: true, onMouseLeave: this.toggle }, tagStore.groups.map((group, index) => {
                const tags = tagStore.getFilteredTags({ group: group, type: type });
                if (tags.length === 0) {
                    return null;
                }
                if (first < 0) {
                    first = index;
                }
                return (React.createElement("div", { key: index },
                    index > 0 && first !== index && React.createElement(reactstrap_1.DropdownItem, { divider: true }),
                    React.createElement(reactstrap_1.DropdownItem, { header: true }, group.label),
                    tags.map((tag, ti) => (React.createElement(reactstrap_1.DropdownItem, { key: ti, toggle: false, active: tag.selected, tag: react_router_dom_1.Link, to: `?q=${tagStore.getQuery(tag.code)}` }, tag.label)))));
            }))));
    }
}
exports.DropDownList = DropDownList;
exports.default = mobx_react_1.inject('tagStore')(mobx_react_1.observer(DropDownList));
